/* Pickup vs Ship-to-Home: product selector, store drawer, cart line switching.
   Markup: snippets/fasc-fulfillment.liquid, fasc-store-drawer.liquid, fasc-fulfillment-badge.liquid */
(function () {
  'use strict';

  var STORAGE_KEY = 'fasc_pickup_store';
  var PICKUP_VALUE = 'In-Store Pickup';
  var SHIP_VALUE = 'Ship to Home';

  function getSavedStore() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || null; } catch (e) { return null; }
  }
  function saveStore(store) {
    try {
      if (store) localStorage.setItem(STORAGE_KEY, JSON.stringify({ id: String(store.id), name: store.name, label: store.label, address: store.address }));
      else localStorage.removeItem(STORAGE_KEY);
    } catch (e) { /* private mode */ }
  }
  function rootUrl() {
    return (window.routes && window.routes.rootUrlWithoutSlash) || '';
  }

  /* ------------------------------------------------------------------ drawer */
  var drawer = null;
  var drawerOnSelect = null;
  var drawerOpener = null;

  // preferred: the selector's own drawer, so a quick view on a product page doesn't reuse the page's (other product) drawer.
  function getDrawer(preferred) {
    if (preferred) drawer = preferred;
    else if (drawer && document.body.contains(drawer)) return drawer;
    else drawer = document.querySelector('[data-fasc-drawer]');
    if (!drawer) return null;
    if (drawer.parentNode !== document.body) document.body.appendChild(drawer); // escape any transformed ancestor
    return drawer;
  }

  function storeFromRow(row) {
    var btn = row.querySelector('[data-ff-select]');
    return {
      id: row.getAttribute('data-location-id'),
      name: btn ? btn.getAttribute('data-store-name') : '',
      label: (row.querySelector('.fasc-drawer__item-name') || {}).textContent || '',
      address: (row.querySelector('.fasc-drawer__item-addr') || {}).textContent || '',
      available: row.getAttribute('data-available') === 'true'
    };
  }

  // opts: { drawer, availability: {locationId: bool} | null, selectedId, context, onSelect(store), opener }
  function openDrawer(opts) {
    var d = getDrawer(opts.drawer);
    if (!d) return;
    drawerOnSelect = opts.onSelect;
    drawerOpener = opts.opener || null;

    var ctx = d.querySelector('[data-ff-drawer-context]');
    if (ctx && opts.context != null) ctx.textContent = opts.context;

    d.querySelectorAll('[data-ff-store-row]').forEach(function (row) {
      var id = row.getAttribute('data-location-id');
      var info = opts.availability ? opts.availability[id] : undefined;
      if (info !== undefined) {
        var isAvailable = (info && typeof info === 'object') ? !!info.available : !!info;
        row.setAttribute('data-available', isAvailable ? 'true' : 'false');
      }
      var available = row.getAttribute('data-available') === 'true';
      var stock = row.querySelector('[data-ff-row-stock]');
      if (stock && info !== undefined) {
        stock.textContent = available
          ? 'In stock' + (info && info.pickup_time ? ' · ' + String(info.pickup_time).toLowerCase() : '')
          : 'Not in stock at this store';
      }
      var selected = String(opts.selectedId || '') === id ||
        (!!opts.selectedName && !!row.querySelector('[data-ff-select]') && row.querySelector('[data-ff-select]').getAttribute('data-store-name') === opts.selectedName);
      row.classList.toggle('is-selected', selected);
      var btn = row.querySelector('[data-ff-select]');
      if (btn) {
        btn.disabled = !available;
        var label = btn.querySelector('[data-ff-select-label]') || btn;
        label.textContent = selected ? 'Selected' : (available ? 'Select' : 'Unavailable');
      }
      row.hidden = false;
    });
    var search = d.querySelector('[data-ff-search]');
    if (search) search.value = '';
    var empty = d.querySelector('[data-ff-no-results]');
    var anyAvailable = !!d.querySelector('[data-ff-store-row][data-available="true"]');
    if (empty) {
      empty.textContent = anyAvailable ? 'No stores match that search.' : 'This item is not available for pickup at any store right now.';
      empty.hidden = anyAvailable;
    }

    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('fasc-drawer-open');
    setTimeout(function () { if (search) search.focus(); }, 60);
  }

  function closeDrawer() {
    var d = getDrawer();
    if (!d || d.getAttribute('aria-hidden') === 'true') return;
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('fasc-drawer-open');
    drawerOnSelect = null;
    if (drawerOpener && document.body.contains(drawerOpener)) drawerOpener.focus();
    drawerOpener = null;
  }

  function filterDrawer(query) {
    var d = getDrawer();
    if (!d) return;
    var q = (query || '').trim().toLowerCase();
    var shown = 0;
    d.querySelectorAll('[data-ff-store-row]').forEach(function (row) {
      var hit = !q || (row.getAttribute('data-search') || '').indexOf(q) !== -1;
      row.hidden = !hit;
      if (hit) shown++;
    });
    var empty = d.querySelector('[data-ff-no-results]');
    if (empty) { empty.textContent = 'No stores match that search.'; empty.hidden = shown > 0; }
  }

  /* ------------------------------------------------------- product selector */
  function initSelector(root) {
    if (root.__ff) return;
    var dataEl = root.querySelector('[data-ff-stores]');
    var stores = [];
    try { stores = JSON.parse(dataEl.textContent); } catch (e) { return; }
    stores.forEach(function (s) { s.id = String(s.id); });
    root.__ff = { stores: stores, store: null, drawer: root.querySelector('[data-fasc-drawer]'), rules: {
      pickup_only: root.getAttribute('data-pickup-only') === 'true',
      ship_only: root.getAttribute('data-ship-only') === 'true',
      shippable: root.getAttribute('data-shippable') === 'true',
      pickup_possible: root.getAttribute('data-pickup-possible') === 'true'
    } };

    var saved = getSavedStore();
    var store = saved ? stores.filter(function (s) { return s.id === String(saved.id); })[0] : null;
    root.__ff.store = store || null;

    // Default to pickup only when the shopper already has a store and the item is in stock there.
    if (!root.__ff.rules.pickup_only && !root.__ff.rules.ship_only && store && store.available) setMethod(root, 'pickup');
    applyRules(root);
    render(root);
  }

  // Locks tiles to what the variant can actually do (see snippets/fasc-fulfillment-rules.liquid).
  function applyRules(root) {
    var r = root.__ff.rules;
    var pickup = root.querySelector('[data-ff-method="pickup"]');
    var ship = root.querySelector('[data-ff-method="ship"]');
    var pickupTile = root.querySelector('[data-ff-tile="pickup"]');
    var shipTile = root.querySelector('[data-ff-tile="ship"]');

    pickup.disabled = !!r.ship_only;
    ship.disabled = !!r.pickup_only;
    pickup.value = r.pickup_only ? pickup.getAttribute('data-value-pickup-only') : pickup.getAttribute('data-value-pickup');
    pickupTile.classList.toggle('is-disabled', !!r.ship_only);
    shipTile.classList.toggle('is-disabled', !!r.pickup_only);
    root.setAttribute('data-pickup-only', r.pickup_only ? 'true' : 'false');
    root.setAttribute('data-ship-only', r.ship_only ? 'true' : 'false');

    if (r.pickup_only) pickup.checked = true;
    else if (r.ship_only) ship.checked = true;
    else if (!pickup.checked && !ship.checked) ship.checked = true;

    var shipStatus = root.querySelector('[data-ff-ship-status]');
    if (shipStatus) shipStatus.textContent = r.pickup_only ? 'In-store pickup only' : (shipStatus.getAttribute('data-ship-cost') || '');
  }

  function currentMethod(root) {
    var checked = root.querySelector('[data-ff-method]:checked');
    return checked ? checked.getAttribute('data-ff-method') : 'ship';
  }
  function setMethod(root, method) {
    var input = root.querySelector('[data-ff-method="' + method + '"]');
    if (input && !input.disabled) input.checked = true;
  }

  function render(root) {
    var state = root.__ff;
    var store = state.store;
    var method = currentMethod(root);
    var isPickup = method === 'pickup';

    var card = root.querySelector('[data-ff-store]');
    var empty = root.querySelector('[data-ff-store-empty]');
    card.hidden = !(isPickup && store);
    empty.hidden = !(isPickup && !store);

    var input = root.querySelector('[data-ff-store-input]');
    input.value = store ? store.name : '';
    input.disabled = !(isPickup && store);

    var status = root.querySelector('[data-ff-pickup-status]');
    status.classList.remove('is-ok', 'is-warn');
    if (state.rules.ship_only) {
      status.textContent = 'Not available for pickup';
      card.hidden = true; empty.hidden = true; input.disabled = true;
      return;
    }
    if (!store) {
      status.textContent = 'Choose a store to check stock';
    } else if (store.available) {
      status.textContent = 'In stock at ' + store.label;
      status.classList.add('is-ok');
    } else {
      status.textContent = 'Not in stock at ' + store.label;
      status.classList.add('is-warn');
    }

    if (store) {
      root.querySelector('[data-ff-store-name]').textContent = store.label;
      root.querySelector('[data-ff-store-addr]').textContent = store.address;
      var stock = root.querySelector('[data-ff-store-stock]');
      stock.classList.toggle('is-warn', !store.available);
      stock.textContent = store.available
        ? 'In stock · ' + String(store.pickup_time || 'usually ready in 1 hour').toLowerCase()
        : 'Not in stock here · choose another store';
    }
  }

  function availabilityMap(stores) {
    var map = {};
    stores.forEach(function (s) { map[s.id] = { available: !!s.available, pickup_time: s.pickup_time }; });
    return map;
  }

  function chooseStore(root, picked) {
    var state = root.__ff;
    var store = state.stores.filter(function (s) { return s.id === String(picked.id); })[0];
    if (!store) return;
    state.store = store;
    saveStore(store);
    setMethod(root, 'pickup');
    render(root);
    // Other selectors on the page (quick view, sticky bar) follow the same store.
    document.querySelectorAll('[data-fasc-ff]').forEach(function (other) {
      if (other === root || !other.__ff) return;
      other.__ff.store = other.__ff.stores.filter(function (s) { return s.id === store.id; })[0] || null;
      render(other);
    });
  }

  // Resolves to { "<locationId>": { available, pickup_time, name, label, address, search } }
  function fetchAvailability(variantId) {
    return fetch(rootUrl() + '/variants/' + variantId + '?section_id=fasc-store-availability', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ff-availability]');
        if (!el) return { stores: {}, rules: null };
        var data = JSON.parse(el.textContent);
        return { stores: data.stores || {}, rules: data.rules || null };
      });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  // Cart pages render an empty drawer shell; rows come from the availability JSON.
  function ensureDrawerRows(stores) {
    var d = getDrawer();
    if (!d) return;
    var list = d.querySelector('[data-ff-store-list]');
    if (!list || list.querySelector('[data-ff-store-row]')) return;
    var html = Object.keys(stores).map(function (id) {
      var s = stores[id];
      return '<li class="fasc-drawer__item" role="listitem" data-ff-store-row data-location-id="' + escapeHtml(id) + '" data-available="' + (s.available ? 'true' : 'false') + '" data-search="' + escapeHtml(s.search) + '">' +
        '<div class="fasc-drawer__item-main"><span class="fasc-drawer__item-name">' + escapeHtml(s.label) + '</span>' +
        '<span class="fasc-drawer__item-addr">' + escapeHtml(s.address) + '</span>' +
        '<span class="fasc-drawer__item-stock" data-ff-row-stock></span></div>' +
        '<button type="button" class="fasc-drawer__select" data-ff-select="' + escapeHtml(id) + '" data-store-name="' + escapeHtml(s.name) + '"><span data-ff-select-label>Select</span></button></li>';
    }).join('');
    var empty = list.querySelector('[data-ff-no-results]');
    list.insertAdjacentHTML('afterbegin', html);
    if (empty) list.appendChild(empty);
  }

  function refreshVariant(root, variantId) {
    if (!variantId || String(variantId) === root.getAttribute('data-variant-id')) return;
    root.setAttribute('data-variant-id', variantId);
    fetchAvailability(variantId)
      .then(function (data) {
        if (String(variantId) !== root.getAttribute('data-variant-id')) return; // stale response
        root.__ff.stores.forEach(function (s) {
          var info = data.stores[s.id];
          if (info) { s.available = !!info.available; s.pickup_time = info.pickup_time; }
        });
        if (data.rules) root.__ff.rules = data.rules;
        applyRules(root);
        render(root);
      })
      .catch(function () { /* keep previous availability */ });
  }

  /* --------------------------------------------------------------- cart lines */
  function fetchCart() {
    return fetch(rootUrl() + '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { cart.items.forEach(function (item, i) { item.line = i + 1; }); return cart; });
  }

  function isPickupItem(item) { return /ickup/.test((item.properties || {})['Fulfillment'] || ''); }
  function isLockedItem(item) { return /only/.test((item.properties || {})['Fulfillment'] || ''); }

  // Rewrites Fulfillment / Pickup Store on each item, last line first: an edit can merge a line into an
  // identical one and shift the lines after it, never the ones before.
  function setFulfillment(items, mode, store) {
    return items.slice().sort(function (a, b) { return b.line - a.line; }).reduce(function (chain, item) {
      return chain.then(function () {
        var props = {};
        Object.keys(item.properties || {}).forEach(function (k) {
          if (k !== 'Fulfillment' && k !== 'Pickup Store') props[k] = item.properties[k];
        });
        if (mode === 'pickup') {
          props['Fulfillment'] = isLockedItem(item) ? item.properties['Fulfillment'] : PICKUP_VALUE;
          props['Pickup Store'] = store.name;
        } else {
          props['Fulfillment'] = SHIP_VALUE;
        }
        return fetch(rootUrl() + '/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ line: item.line, quantity: item.quantity, properties: props })
        }).then(function (r) { if (!r.ok) throw new Error('cart change failed'); });
      });
    }, Promise.resolve());
  }

  function changeLine(button, mode, store) {
    var line = parseInt(button.getAttribute('data-line'), 10);
    button.disabled = true;
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    return fetchCart()
      .then(function (cart) {
        var item = cart.items[line - 1];
        if (!item) throw new Error('line missing');
        return setFulfillment([item], mode, store);
      })
      .then(function () {
        if (window.theme && window.theme.pageType === 'cart') { window.location.reload(); return; }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
      })
      .catch(function () {
        button.disabled = false;
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      });
  }

  function lineAvailability(button) {
    button.disabled = true;
    return fetchAvailability(button.getAttribute('data-variant-id'))
      .then(function (data) { button.disabled = false; ensureDrawerRows(data.stores); return data; })
      .catch(function () { button.disabled = false; return { stores: {}, rules: null }; });
  }

  /* ------------------------------------------- whole cart: one method per order */
  function bulkMessage(text) {
    var msg = document.querySelector('[data-ff-bulk-msg]');
    if (msg) { msg.textContent = text; msg.hidden = !text; }
  }

  function bulkFulfillment(button) {
    var mode = button.getAttribute('data-ff-bulk');
    button.disabled = true;
    bulkMessage('');
    fetchCart()
      .then(function (cart) {
        var items = cart.items.filter(function (i) { return i.requires_shipping; });
        return Promise.all(items.map(function (item) {
          return fetchAvailability(item.variant_id).then(function (data) { return { item: item, data: data }; });
        }));
      })
      .then(function (rows) {
        button.disabled = false;
        var names = function (list) { return list.map(function (r) { return r.item.product_title; }).join(', '); };

        if (mode === 'ship') {
          var stuck = rows.filter(function (r) { return (r.item.properties || {})['Fulfillment'] && !(r.data.rules && r.data.rules.shippable); });
          if (stuck.length) { bulkMessage('Pickup only, can\'t be shipped: ' + names(stuck) + '. Remove it to ship the rest, or choose pickup.'); return; }
          return setFulfillment(rows.filter(function (r) { return isPickupItem(r.item); }).map(function (r) { return r.item; }), 'ship')
            .then(function () { window.location.reload(); });
        }

        var noPickup = rows.filter(function (r) { return r.data.rules && r.data.rules.ship_only; });
        if (noPickup.length) { bulkMessage('Ship only, can\'t be picked up: ' + names(noPickup) + '. Remove it to pick up the rest, or choose shipping.'); return; }
        // A store qualifies only if every item is in stock there.
        var shared = {};
        if (rows.length) {
          Object.keys(rows[0].data.stores).forEach(function (id) {
            var info = rows[0].data.stores[id];
            shared[id] = { available: rows.every(function (r) { return r.data.stores[id] && r.data.stores[id].available; }), pickup_time: info.pickup_time };
          });
          ensureDrawerRows(rows[0].data.stores);
        }
        var anyStore = Object.keys(shared).some(function (id) { return shared[id].available; });
        if (!anyStore) { bulkMessage('No single store has every item in stock. Choose shipping, or remove the items that aren\'t available.'); return; }
        var saved = getSavedStore();
        openDrawer({
          availability: shared,
          selectedId: saved ? saved.id : null,
          context: 'Stores with every item in stock',
          opener: button,
          onSelect: function (store) {
            saveStore(store);
            button.disabled = true;
            // Lines without a Fulfillment property (free gifts) are left as-is; they follow the order.
            setFulfillment(rows.filter(function (r) { return (r.item.properties || {})['Fulfillment']; }).map(function (r) { return r.item; }), 'pickup', store)
              .then(function () { window.location.reload(); })
              .catch(function () { button.disabled = false; bulkMessage('Something went wrong. Please refresh and try again.'); });
          }
        });
      })
      .catch(function () { button.disabled = false; bulkMessage('Something went wrong. Please refresh and try again.'); });
  }

  function pickStoreForLine(button, availability) {
    var saved = getSavedStore();
    var current = button.getAttribute('data-store-name');
    openDrawer({
      availability: availability,
      selectedId: current ? null : (saved ? saved.id : null),
      selectedName: current || null,
      context: 'Showing stock for this item',
      opener: button,
      onSelect: function (store) { saveStore(store); changeLine(button, 'pickup', store); }
    });
  }

  /* ------------------------------------------------------------------ events */
  document.addEventListener('change', function (e) {
    var radio = e.target.closest && e.target.closest('[data-ff-method]');
    if (!radio) return;
    var root = radio.closest('[data-fasc-ff]');
    if (root && root.__ff) render(root);
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-ff-search]')) filterDrawer(e.target.value);
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    var opener = t.closest('[data-ff-open-drawer]');
    if (opener) {
      e.preventDefault();
      var root = opener.closest('[data-fasc-ff]');
      if (!root || !root.__ff) return;
      openDrawer({
        drawer: root.__ff.drawer,
        availability: availabilityMap(root.__ff.stores),
        selectedId: root.__ff.store ? root.__ff.store.id : null,
        context: null,
        opener: opener,
        onSelect: function (store) { chooseStore(root, store); }
      });
      return;
    }

    var select = t.closest('[data-ff-select]');
    if (select) {
      e.preventDefault();
      if (select.disabled) return;
      var row = select.closest('[data-ff-store-row]');
      var store = storeFromRow(row);
      var cb = drawerOnSelect;
      closeDrawer();
      if (cb) cb(store);
      return;
    }

    if (t.closest('[data-ff-close]')) { e.preventDefault(); closeDrawer(); return; }

    var sw = t.closest('[data-ff-switch]');
    if (sw) {
      e.preventDefault();
      var mode = sw.getAttribute('data-ff-switch');
      if (sw.disabled) return;
      if (mode === 'ship') {
        lineAvailability(sw).then(function (data) {
          if (data.rules && data.rules.shippable) { changeLine(sw, 'ship'); return; }
          sw.textContent = 'Pickup only · can\'t ship';
          sw.disabled = true;
        });
        return;
      }
      lineAvailability(sw).then(function (data) {
        var saved = getSavedStore();
        var info = saved && data.stores[saved.id];
        if (info && info.available) changeLine(sw, 'pickup', saved);
        else pickStoreForLine(sw, data.stores);
      });
      return;
    }

    var bulk = t.closest('[data-ff-bulk]');
    if (bulk) {
      e.preventDefault();
      if (!bulk.disabled) bulkFulfillment(bulk);
      return;
    }

    var change = t.closest('[data-ff-change-store]');
    if (change) {
      e.preventDefault();
      if (change.disabled) return;
      lineAvailability(change).then(function (data) { pickStoreForLine(change, data.stores); });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // Warehouse fires this from the product form when options change.
  document.addEventListener('variant:changed', function (e) {
    var section = e.target.closest ? e.target.closest('[data-section-type="product"]') : null;
    var scope = section || document;
    var variant = e.detail && e.detail.variant;
    scope.querySelectorAll('[data-fasc-ff]').forEach(function (root) {
      if (root.__ff) refreshVariant(root, variant && variant.id);
    });
  });

  function initAll() {
    document.querySelectorAll('[data-fasc-ff]').forEach(initSelector);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // Quick view / sections rendered later.
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches('[data-fasc-ff]') || n.querySelector('[data-fasc-ff]'))) { initAll(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
